import { Component, Vue } from "vue-property-decorator";
import _com from '@/assets/js/common';
import jsonp from "../../assets/js/http";
@Component({
	filters: {
		tvStatus(value: number) {
			switch (value) {
				case 0:
					return '未开播';
				case 1:
					return '已开播';
				case 2:
					return '已结束';
			}
		},
		tvType(value: number) {
			switch (value) {
				case 1:
					return '邮掌柜';
				case 2:
					return '邮助手';
				case 3:
					return '邮乐优鲜';
				case 4:
					return '邮乐零售';
				case 5:
					return '邮乐小店';
				case 6:
					return '邮生活';
			}
		}
	}
})
export default class AttentionList extends Vue {
	pageNum: number = 1 // 第几页
	list: any = [] // 关注列表
	loading: boolean = false // loading
	finished: boolean = false // 加载完所有数据
	isFirst: boolean = true // 列表接口第一次加载
	isShowEmpty: boolean = false // 无数据显示
	browser: any = {}
	isShowHeader: boolean = true
	isShowNavBar: boolean = true
	created() {
		this.browser = _com.browser()
		this.getList()

		if (this.browser.ylxd || this.browser.ule) {
			this.isShowHeader = false
			try {
				(<any>window).dsBridge.call("setNativeTitle", {
					title: "直播关注"
				});
			} catch (e) { }
		}
		this.isShowNavBar = !(window.navigator.userAgent.toLowerCase().indexOf('unicom') > -1 || this.$route.query.isNavBar == '1')
	}

	// 返回
	onClickLeft() {
		if (Object.keys(this.browser).length > 0) {
			location.href = "ULEMOBILE://ulePopView";
		} else {
			history.go(-1)
		}
	}

	// 获取关注列表
	getList() {
		this.loading = true
		let callback = "getfollow";
		let url = `https://pub${this.domain}/live/user/follow/page?page_num=${this.pageNum}`
		jsonp(url, {
			jsonpcallback: callback,
			jsonp: 'callback',
		}).then((res: any) => {
			this.loading = false

			// 给每项添加关注状态
			res.datas.forEach((ele: any) => {
				ele.isFlow = true
			})

			if (res.datas.length < 10) {
				this.finished = true
			}

			if (this.isFirst) {
				this.isFirst = false

				if (res.datas.length > 0) {
					this.list = res.datas
				} else {
					this.isShowEmpty = true
				}
			} else {
				this.list = this.list.concat(res.datas)
			}

			this.pageNum++
		}).catch((res: any) => {
			this.loading = false
		})
	}

	// 取消关注
	async attention(obj: any) {
		let confirm = await this.$dialog.confirm({
			title: '温馨提示',
			message: '取消关注将不会收到该房间的开播提醒了哟',
			confirmButtonText: '不再关注',
			cancelButtonText: '考虑一下'
		})

		if (!confirm) {
			return false
		}
		let callback = "changeUserFollow";
		jsonp(
			 `https://pub${this.domain}/live/user/follow/changeUserFollowCallable?room_id=${obj.id}&flag=${0}&originType=${obj.tvType}&callback=${callback}`,
			 {
				jsonpcallback: callback,
				jsonp: 'callback',
			}
		).then((res: any) => {
			let objId = this.list.findIndex((item: any) => { return item.id == obj.id })
			let list = this.list
			list.splice(objId, 1)
			this.list = list
		})
	}
	// 前往直播页面
	goDetail(obj: any) {
		// 邮小店可以正常进入
		if (obj.tvType == 5) {
			this.$router.push(`/broadLive/${obj.id}/${obj.roomNumber}`)
		} else {
			this.$dialog.alert({
				title: '提示',
				message: '该房间已不是小店渠道直播，暂时无法观看',
				confirmButtonText: '知道了'
			})
		}
	}
}
